var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"powered"},[_c('img',{attrs:{"src":_vm.image,"alt":"梨子助教"}})])}
var staticRenderFns = []

export { render, staticRenderFns }